import { FC } from 'react';
import { CaretPosition } from '../../components/Button/Button.types';
import StepTracker from '../../components/StepTracker/StepTracker';
import { StepTrackerWrapper, StyledHeader, StyledLink, Title } from './Header.styles';
import { HeaderProps } from './Header.types';

const Header: FC<HeaderProps> = ({ breadcrumb, title, stepTracker, titleTestId = 'HeaderTitle'}) => {
  return (
    <StyledHeader>
      <div>
        <StyledLink
          to={breadcrumb.to}
          caret={CaretPosition.Left}
          label={breadcrumb.label}
          onClick={breadcrumb.onClick}
          id='skipNavTarget'
        />
        {title && <Title data-testid={titleTestId}>{title}</Title>}
      </div>
      {stepTracker !== undefined && (
        <StepTrackerWrapper>
          <StepTracker {...stepTracker} />
        </StepTrackerWrapper>
      )}
    </StyledHeader>
  );
};

export default Header;
